<microempresario-header></microempresario-header>
<div class="encuesta-v2">
  <div class="encuesta-v2__inner">
    <header class="encuesta-v2__header">
      <h1 class="encuesta-v2__title">Encuesta de satisfacción</h1>
      <p class="encuesta-v2__subtitle">Tu opinión nos ayuda a mejorar neocrédito.</p>
    </header>

    <div class="encuesta-v2__panel">
      <form (ngSubmit)="validateForm()">
        <div class="encuesta-v2__field">
          <label for="numSolicitud" class="encuesta-v2__label">Número de solicitud</label>
          <div class="encuesta-v2__readonly" id="numSolicitud">{{ idSolicitud }}</div>
        </div>

        @for (pregunta of preguntas; track pregunta; let i = $index) {
          <div class="encuesta-v2__field">
            <label class="encuesta-v2__label">
              Pregunta {{ i + 1 }}. {{ pregunta.pregunta }} *
            </label>
            @if (pregunta.opcionesRespuesta != null) {
              <select
                class="encuesta-v2__control"
                (change)="guardarRespuesta(pregunta, $event.target.value)"
              >
                <option value="">Seleccione una opción</option>
                @for (opcion of pregunta.opcionesRespuesta; track opcion) {
                  <option [value]="opcion">{{ opcion }}</option>
                }
              </select>
            }
            @if (pregunta.opcionesRespuesta == null) {
              <textarea
                class="encuesta-v2__control encuesta-v2__textarea"
                maxlength="500"
                rows="3"
                (keyup)="guardarRespuesta(pregunta, $event.target.value)"
              ></textarea>
            }
          </div>
        }

        @if (video?.estado == 'HABILITADO') {
          <div class="encuesta-v2__field">
            <label class="encuesta-v2__label">
              Pregunta 5. ¿Deseas contarnos tu experiencia en neocrédito? Puedes cargar un video de máximo 2
              minutos en donde nos cuentes tus opiniones o comentarios del canal, el cual podrá publicarse en la
              plataforma.
            </label>

            <div class="encuesta-v2__video-card" [class.encuesta-v2__video-card--loaded]="hasVideo">
              <div class="encuesta-v2__video-card-header">
                <div class="encuesta-v2__video-card-text">
                  <p class="encuesta-v2__video-card-title">{{ videoLabel }}</p>
                  <p class="encuesta-v2__video-card-hint">
                    Máximo 2 minutos · {{ video?.extensionesValidas || 'mp4, webm, mov' }}
                  </p>
                </div>
                <div class="encuesta-v2__video-card-actions">
                  <input
                    #fileAdiocional
                    type="file"
                    class="encuesta-v2__video-input"
                    [accept]="video?.tipoArchivoPermitido"
                    [attr.aria-label]="videoLabel"
                    (click)="fileAdiocional.value = null"
                    (change)="saveVideo($event)"
                  />
                  <button
                    type="button"
                    class="encuesta-v2__video-upload-btn"
                    id="btn-encuesta-cargar-video"
                    [disabled]="hasVideo"
                    (click)="fileAdiocional.click()"
                  >
                    <span>Cargar video</span>
                    <span class="material-icons" aria-hidden="true">upload</span>
                  </button>
                </div>
              </div>

              @if (hasVideo) {
                <div class="encuesta-v2__video-file" role="status">
                  <img
                    class="encuesta-v2__video-file-icon"
                    [src]="archivoIcon"
                    alt=""
                    width="24"
                    height="24"
                  />
                  <div class="encuesta-v2__video-file-meta">
                    <p class="encuesta-v2__video-file-name">
                      {{ videoFileName || video?.neoDocumentosSolicitudDTO?.nombreArchivo || 'Video cargado' }}
                    </p>
                    <p class="encuesta-v2__video-file-status">
                      @if (videoSizeLabel) {
                        <span>{{ videoSizeLabel }}</span>
                        <span aria-hidden="true"> · </span>
                      }
                      <span>Archivo subido</span>
                    </p>
                  </div>
                  <button
                    type="button"
                    class="encuesta-v2__video-file-remove"
                    aria-label="Quitar video"
                    (click)="deleteVideo(video.neoDocumentosSolicitudDTO.idBanner)"
                  >
                    <span class="material-icons" aria-hidden="true">close</span>
                  </button>
                </div>

                <video
                  class="encuesta-v2__video-preview"
                  [src]="video.neoDocumentosSolicitudDTO?.urlArchivo"
                  controls
                  title="Reproducir video"
                >
                  Su navegador no soporta la etiqueta de vídeo.
                </video>
              }
            </div>
          </div>
        }

        <div class="encuesta-v2__actions">
          <button
            type="submit"
            class="encuesta-v2__btn encuesta-v2__btn--primary"
            id="btn-encuesta-registrar"
          >
            Registrar respuestas
          </button>
          <button
            type="button"
            class="encuesta-v2__btn encuesta-v2__btn--secondary"
            id="btn-encuesta-volver"
            routerLink="/microempresario/home"
            (click)="trackVolver()"
          >
            Volver
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="home-v2__bubbles" aria-hidden="true">
    <span class="home-v2__bubble home-v2__bubble--lg"></span>
    <span class="home-v2__bubble home-v2__bubble--sm"></span>
  </div>
</div>

<div class="home-v2__chrome">
  <app-home-site-footer></app-home-site-footer>
</div>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
